import { downloadFile } from './downloadFile';
import { exportDocumentToJson } from './exportDocumentToJson';
export function downloadDocumentToJson(data, filename) {
    downloadFile(exportDocumentToJson(data), `${filename}.json`, 'application/json');
}
